
import { Field } from '../../models/field.model';
import { CalendarFruitType } from '../calendar/calendar.model';

export type FieldCalendarStatus =
  | 'harvest-ready'
  | 'harvest-window'
  | 'sowing-window'
  | 'none';

export interface FieldCalendarInfo {
  status: FieldCalendarStatus;
  label: string;
  description: string;
}

export function getFieldCalendarInfo(
  field: Field,
  fruitTypes: CalendarFruitType[],
  period: number | null,
): FieldCalendarInfo {
  if (field.growthStatus === 'HARVESTABLE') {
    return {
      status: 'harvest-ready',
      label: 'Erntebereit',
      description: 'Das Feld ist laut Spielstand erntereif.',
    };
  }

  if (period === null || period < 1 || period > 12) {
    return {
      status: 'none',
      label: '',
      description: '',
    };
  }

  const currentFruit = fruitTypes.find(
    (fruit) =>
      fruit.fruitTypeIndex === field.fruitTypeIndex,
  );

  if (
    field.stateValid &&
    field.growthStatus === 'GROWING' &&
    currentFruit?.harvestPeriods.includes(period)
  ) {
    return {
      status: 'harvest-window',
      label: 'Erntefenster',
      description:
        'Die aktuelle Frucht liegt im Erntezeitraum. Das Feld ist noch nicht als erntereif gemeldet.',
    };
  }

  const plannedFruitIndex =
    field.plannedFruitTypeIndex ??
    field.plannedCrop?.id ??
    null;

  const plannedFruit = fruitTypes.find(
    (fruit) =>
      fruit.fruitTypeIndex === plannedFruitIndex ||
      (
        field.plannedCrop !== null &&
        fruit.name.toLowerCase() ===
        field.plannedCrop.code.toLowerCase()
      ),
  );

  if (
    plannedFruit?.plantingPeriods.includes(period)
  ) {
    return {
      status: 'sowing-window',
      label: 'Aussaatfenster',
      description:
        'Die geplante Frucht kann laut Spielkalender in diesem Monat gesät werden. Die tatsächliche Feldbefahrbarkeit wird nicht geprüft.',
    };
  }

  return {
    status: 'none',
    label: '',
    description: '',
  };
}
